/* eslint-disable @typescript-eslint/naming-convention */
import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateValidator(control: AbstractControl): ValidationErrors | null {
  const dateObj = control.value;
  if (!dateObj) {
    return null;
  }

  const { day, month, year } = dateObj;

  if (!validateDateStruct(dateObj)) {
    return { dateFormatInvalid: true };
  }

  const dayNum = parseInt(day, 10);
  const monthNum = parseInt(month, 10);
  // Adjusting for JavaScript month indexing (0-11)
  const adjustedMonthNum = monthNum - 1;
  const yearNum = parseInt(year, 10);

  if (isNaN(dayNum) || isNaN(monthNum) || isNaN(yearNum)) {
    return { dateInvalid: true };
  }

  // Check for leap year
  const isLeapYear = (year: number): boolean => {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  };

  // Adjust February days for leap years
  const maxDaysPerMonth: { [key: number]: number } = {
    1: 31,
    2: isLeapYear(yearNum) ? 29 : 28,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31
  };

  const dayValid = dayNum > 0 && dayNum <= (maxDaysPerMonth[monthNum] || 31);
  const monthValid = monthNum > 0 && monthNum <= 12;
  const yearValid = yearNum > 1900 && yearNum <= new Date().getFullYear();

  if (!dayValid || !monthValid || !yearValid) {
    return { dateInvalid: true };
  }

  // Prevent future dates
  const inputDate = new Date(yearNum, adjustedMonthNum, dayNum);
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0); // Normalize the current date to midnight for fair comparison

  if (inputDate > currentDate) {
    return { futureDate: true };
  }

  return null; // if everything is valid
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function validateDateStruct(dateObj: any): boolean {
  const { day, month, year } = dateObj;

  // Regular expressions to validate the DD/MM/YYYY format
  const dayRegex = /^\d{2}$/;
  const monthRegex = /^\d{2}$/;
  const yearRegex = /^\d{4}$/;

  const formatValid = dayRegex.test(day) && monthRegex.test(month) && yearRegex.test(year);
  return formatValid;
}
